
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
import { ElMessage } from "element-plus";
import MiezzButton from "@/models/MiezzButton";
import MiezzForm from "@/models/MiezzForm";
import MiezzModal from "@/models/MiezzModal";
import PriceTableAppService from "@/apis.machine/PriceTableAppService";
import DtoFormPriceTable, {
  DtoFormPriceTableMiezzFormItems,
  DtoFormPriceTableRules,
} from "@/models.machine/DtoFormPriceTable";

export default class PriceTableForm extends Vue {
  @Model() modelValue!: MiezzModal;
  @Prop() id?: string;
  @Prop() copyId?: string;

  form = new MiezzForm<DtoFormPriceTable, string>();

  created(): void {
    //表单-数据-初始化
    this.form.Data = new DtoFormPriceTable();
    //表单-校验
    this.form.Rules = DtoFormPriceTableRules;
    this.form.Rules.Name = [
      {
        required: true,
        message: "信息不能为空",
        trigger: "blur",
      },
      {
        max: 256,
        message: "文本长度不能超过 256 个字符",
        trigger: "blur",
      },
      {
        validator: (rule: any, value: string, callback: any) => {
          if (value) {
            PriceTableAppService.CheckExist(
              this.form.Data.Id,
              this.form.Data.Name
            ).then((r) => {
              if (r.data.Data) {
                return callback(new Error("信息重复，请重新填写"));
              } else {
                callback();
              }
            });
          }
        },
        trigger: "blur",
      },
    ];
    //表单-元素配置
    this.form.Items = DtoFormPriceTableMiezzFormItems;

    //修改元素配置
    //for (const item of this.form.Items) {
    //  switch (item.Prop) {
    //    default:
    //      break;
    //  }
    //}

    this.modelValue.HandleClick = this.handleClick;
    this.modelValue.Buttons = [
      {
        Code: "submit",
        Label: "保存",
        Type: "primary",
        Size: "small",
      },
    ];
    if (!this.id) {
      this.modelValue.Buttons.push({
        Code: "submit-again",
        Label: "继续添加",
        Type: "primary",
        Size: "small",
      });
    }

    this.handleGet();
  }

  /**查询表单数据 */
  handleGet(): void {
    if (this.id) {
      PriceTableAppService.GetById(this.id).then((r) => {
        if (r.data.Data) this.form.Data = r.data.Data;
      });
    }
  }

  /**按钮点击 */
  handleClick(btn: MiezzButton, complete: () => void): void {
    switch (btn.Code) {
      case "submit":
      case "submit-again":
        MiezzForm.submit(this.$refs, "ruleForm", (v) => {
          if (v) {
            this.form.Data.CopyId = this.copyId;
            PriceTableAppService.Post(this.form.Data)
              .then(() => {
                if (btn.Code == "submit-again") {
                  this.form.Data = new DtoFormPriceTable();
                } else {
                  this.modelValue.Show = false;
                }
                this.handleSubmit();
                complete();
              })
              .catch(complete);
          } else complete();
        });
        break;
      default:
        break;
    }
  }

  /**表单提交-回调 */
  @Emit()
  handleSubmit(): void {
    //
  }
}
